module.exports = __webpack_public_path__ + "img/book_1.9262a3f3.png";